import config from "@/config"
import http from "@/utils/request"

export default {
	add: {
		url: `${config.API_URL}/modelCommand/`,
		name: "添加型号指令",
		post: async function(data){
			return await http.post(this.url, data);
		}
	},
    delete: {
		url: `${config.API_URL}/modelCommand/`,
		name: "删除型号指令",
		delete: async function(id,data){
			return await http.delete(this.url+id+"/", data);
		}
	},
    detail: {
		url: `${config.API_URL}/modelCommand/`,
		name: "查询型号指令详情",
		get: async function(id,data){
			return await http.get(this.url+id+"/", data);
		}
	},
    list: {
		url: `${config.API_URL}/modelCommand/`,
		name: "查询型号指令列表",
		get: async function(data){
			return await http.get(this.url, data);
		}
	},
    update: {
		url: `${config.API_URL}/modelCommand/`,
		name: "修改型号指令",
		patch: async function(id,data){
			return await http.patch(this.url+id+"/", data);
		}
	},
}
